module.exports = __webpack_public_path__ + "static/img/title.f9d6029.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/media5/title.png
// module id = q/Vq
// module chunks = 7